import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  fetchPaginatedQueryFunction,
  fetchQueryFunction,
  makeQueryKey,
  PaginatedQueryFunction,
  useInfiniteQuery,
  UseInfiniteQueryFunction,
  usePaginatedQuery,
  UsePaginatedQueryFunction,
} from "./queries";
import { PaginatedQueryParams, PaginatedResponse } from "../types";

type Newsletter = {
  id: number;
  name: string;
  slug: string;
  description?: string;
  status: string | null;
  subscriber_count: number;
};

export const fetchNewsletter = (id?: number | string) =>
  fetchQueryFunction<void, Newsletter>({
    path: `newsletters/${id}`,
    resource: "newsletters",
    id,
  });

export const useNewsletter = (
  id?: number | string,
  options?: Omit<UseQueryOptions<Newsletter, Error>, "queryKey" | "queryFn">,
) =>
  useQuery<Newsletter, Error>({
    queryKey: makeQueryKey({ resource: "newsletters", id }),
    queryFn: () => fetchNewsletter(id),
    ...options,
    enabled: !!id && options?.enabled,
  });

export const fetchNewsletters: PaginatedQueryFunction<
  PaginatedQueryParams,
  PaginatedResponse<Newsletter>
> = (params, preload) =>
  fetchPaginatedQueryFunction({
    path: "newsletters",
    resource: "newsletters",
    params,
    preload,
  });

export const useNewsletters: UsePaginatedQueryFunction<
  Newsletter,
  PaginatedQueryParams
> = (params, options) =>
  usePaginatedQuery("newsletters", fetchNewsletters, params, options);

export const useInfiniteNewsletters: UseInfiniteQueryFunction<
  Newsletter,
  PaginatedQueryParams
> = (params, options) =>
  useInfiniteQuery("newsletters", fetchNewsletters, params, options);
